class MCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner");
    this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close");
    this.cartOverlay = this.querySelector(".m-cart__overlay");
    this.rootUrl = window.Shopify.routes.root;

    this.setHeaderCartIconAccessibility();
    this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this));
    this.addEventListener("click", (event) => {
      if (event.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner) {
        this.close();
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll(".m-cart-icon-bubble");
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        if (MinimogSettings.enable_cart_drawer) {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.classList.add("m-cart-drawer--active");
    requestAnimationFrame(() => {
      this.style.setProperty("--m-bg-opacity", "0.5");
      this.cartDrawerInner.style.setProperty("--translate-x", "0");
    });
    window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
    document.documentElement.classList.add("prevent-scroll");

    // 💡 Recalculer la barre à l'ouverture du tiroir
    this.getCart().then((cart) => {
      if (typeof updateGoalBar === "function") {
        updateGoalBar(cart.total_price);
      }
    });
  }

  close() {
    this.style.setProperty("--m-bg-opacity", "0");
    this.cartDrawerInner.style.setProperty("--translate-x", "100%");
    setTimeout(() => {
      this.classList.remove("m-cart-drawer--active");
      document.documentElement.classList.remove("prevent-scroll");
    }, 300);
  }

  renderContents(parsedState) {
    this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // 🟢 Update la barre aussi ici
    this.getCart().then((cart) => {
      if (typeof updateGoalBar === "function") {
        updateGoalBar(cart.total_price);
      }
      this.updateCartCount(cart.item_count);
    });

    setTimeout(() => {
      this.open();
    });
  }

  updateCartCount(itemCount) {
    const cartCounts = document.querySelectorAll(".m-cart-count-bubble");
    cartCounts.forEach((cartCount) => {
      if (itemCount > 0) {
        cartCount.textContent = itemCount;
        cartCount.classList.remove("m:hidden");
      } else {
        cartCount.classList.add("m:hidden");
      }
    });
  }

  getCart() {
    return fetchJSON(this.rootUrl + "cart.json").then((cart) => {
      // 🎯 Mise à jour de la barre à chaque récupération de panier
      if (typeof updateGoalBar === "function") {
        updateGoalBar(cart.total_price);
      }
      return cart;
    });
  }

  onCartDrawerUpdate(updateFooter = true) {
    fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          if (
            section.block === "cart-items" ||
            (section.block === "cart-footer" && updateFooter)
          ) {
            sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
          }
        });
      })
      .catch(console.error);

    this.getCart().then((cart) => {
      this.classList.toggle("m-cart--empty", cart.item_count === 0);
      this.updateCartCount(cart.item_count);
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "[data-minimog-cart-items]", block: "cart-items" },
      { id: "cart-drawer", selector: "[data-minimog-cart-discounts]", block: "cart-footer" },
      { id: "cart-drawer", selector: "[data-cart-subtotal]", block: "cart-footer" },
      { id: "cart-drawer", selector: "[data-minimog-gift-wrapping]", block: "cart-footer" },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("m-cart-drawer", MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
    return [
      { id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-minimog-cart-items]" },
      { id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-minimog-cart-discounts]" },
      { id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-cart-subtotal]" },
      { id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-minimog-gift-wrapping]" },
    ];
  }
}

customElements.define("m-cart-drawer-items", MCartDrawerItems);

 // ⚠️  Powered by Web_experty
  //           ⚠ FR : CONTENU PROTÉGÉ PAR LES DROITS D'AUTEUR
   //          Conformément à l'article L. 111-1 du Code de la propriété intellectuelle, tout le contenu de ce site est strictement protégé. Il est interdit d'utiliser, diffuser ou exploiter ces ressources sans l'autorisation préalable de leurs auteurs.
 //            Pour toute demande d'information ou d'utilisation, veuillez contacter : https://comeup.com/fr/@web-experty.

  //             ⚠ EN: CONTENT PROTECTED BY COPYRIGHT
   //          In accordance with Article L. 111-1 of the French Intellectual Property Code, all content on this site is strictly protected. It is prohibited to use, distribute, or exploit these resources without prior approval from their authors.
   //          
    //         For any inquiries or permissions, please contact: https://comeup.com/fr/@web-experty.   
            

function updateGoalBar(totalCents) {
  const wrapper = document.querySelector('free-shipping-bar');
  if (!wrapper) return;

  const threshold = parseFloat(wrapper.getAttribute('threshold')) || 0;
  const threshold1 = parseFloat(wrapper.getAttribute('threshold1')) || 0;
  const euroTotal = totalCents / 100;

  // ⚠️ Mise à jour de la propriété CSS
  const percent = Math.min((euroTotal / (threshold / 100)) * 100, 100);
  wrapper.style.setProperty('--progress', percent / 100);

  // ⚠️ Mise à jour du texte affiché
  const textSpan = wrapper.querySelector('.shipping-bar__text');
  const remainingToThreshold = ((threshold - totalCents) / 100).toFixed(2);
  const remainingToThreshold1 = ((threshold1 - totalCents) / 100).toFixed(2);

  if (totalCents >= threshold1) {
    textSpan.innerHTML = "Youpi, vous avez débloqué votre cadeau offert !  ! 🎉";
  } else if (totalCents >= threshold) {
    textSpan.innerHTML = `Plus que <strong>${remainingToThreshold1}€</strong> pour votre prochain cadeau 🎁 !`;
  } else {
    textSpan.innerHTML = `Dépensez <strong>${remainingToThreshold}€</strong> pour débloquer votre Masque Facial 🎁 !`;
  }

  // ⚠️ Mise à jour de sbp1 et sbp3
  const sbp1 = wrapper.querySelector('.shipping-bar__progress.sbp1');
  const sbp3 = wrapper.querySelectorAll('.shipping-bar__progress')[2]; // le 3e

  let sbp1_progress = 0;
  if ((threshold1 - threshold) > 0) {
    sbp1_progress = Math.min(Math.max((totalCents - threshold) / (threshold1 - threshold), 0), 1);
  }
  let sbp3_progress = totalCents >= threshold1 ? 1 : 0;

  if (sbp1) sbp1.style.setProperty('--progress', sbp1_progress);
  if (sbp3) sbp3.style.setProperty('--progress', sbp3_progress);
}

